/* @flow */

import { type EtapasId } from '../pedidos/types';
import {
    ETAPA_PENDENTE,
    ETAPA_EXECUCAO,
    ETAPA_ENTREGA,
    ETAPA_FINALIZADO,
    ETAPA_CANCELADO,
    ETAPA_DEVOLVIDO,
} from '../pedidos/constants';

const getTitleHora = (etapasId: EtapasId, minutos: string) => {
    switch (etapasId) {
    case ETAPA_PENDENTE:
    case ETAPA_EXECUCAO:
    case ETAPA_ENTREGA:
        return `O cliente está aguardando a entrega do pedido ${minutos}`;
    case ETAPA_CANCELADO:
        return `O pedido foi finalizado ${minutos}`;
    case ETAPA_FINALIZADO:
        return `O pedido foi cancelado ${minutos}`;
    case ETAPA_DEVOLVIDO:
        return `O pedido foi devolvido ${minutos}`;
    default:
        return '';
    }
};

export default getTitleHora;
